// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ABfb","newExpiryDate":"styles_newExpiryDate__3NGfG","footer":"styles_footer__DUfun"};